import TimeSeriesChartDisplayImage from "./images/TimeSeriesChartDisplayImage.png";
import LineChartDisplayImage from "./images/LineChartDisplayImage.png";
import BarChartDisplayImage from "./images/BarChartDisplayImage.png";
import PieChartDisplayImage from "./images/PieChartDisplayImage.png";
import RangeChartDisplayImage from "./images/RangeChartDisplayImage.png";
import BarChartWithLabelsDisplayImage from "./images/BarChartWithLabelsDisplayImage.png";
import DoughnutDisplayImage from "./images/DoughnutDisplayImage.png";
import StateChartDisplayImage from "./images/StateChartDisplayImage.png";
import PolarAreaDisplayImage from "./images/PolarAreaDisplayImage.png";
import RadarDisplayImage from "./images/RadarDisplayImage.png";
import PointChartDisplayImage from "./images/PointChartDisplayImage.png";
import ValueAndChartCardDisplayImage from "./images/ValueAndChartCardDisplayImage.png";
import { useContext } from "react";
import { DashboardContext } from "../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
const ChartsWidgets = ({ selectedWidgetBundle, setSelectedWidgetBundle}) =>{
    const {setShowWidgetsLibrary, setSelectedNewWidgetWindow} = useContext(DashboardContext);
    if(selectedWidgetBundle !== 'charts') return null;
    return(
        <div className="widgets-library-container">
            <div className="widgets-library-header-container">
                <div style={{display:"flex",alignItems:"center"}}>
                    <p
                        style={{fontWeight:"bold",fontSize:"25px",marginRight:"10px"}}
                        onClick={() => setSelectedWidgetBundle('')}
                    >&#8592;</p>
                    <h3>Charts: Select widget</h3>
                </div>
                <p onClick={() => {
                    setSelectedWidgetBundle('');
                    setShowWidgetsLibrary(false);
                }}>&#10006;</p>
            </div>
            <div className="widgets-library-body-container">
                <div className="widgets-library-grid">
                    <div className="widgets-bundle-container"
                    onClick={() => {
                        setSelectedWidgetBundle('');
                        setShowWidgetsLibrary(false);
                        setSelectedNewWidgetWindow('time_series_chart')
                    }}>
                        <h4>Time series chart</h4>
                        <img src={TimeSeriesChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container"
                    onClick={() =>{
                        setSelectedWidgetBundle('');
                        setShowWidgetsLibrary(false);
                        setSelectedNewWidgetWindow('line_chart');
                    }}>
                        <h4>Line chart</h4>
                        <img src={LineChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container"
                    onClick={() => {
                        setSelectedWidgetBundle('');
                        setShowWidgetsLibrary(false);
                        setSelectedNewWidgetWindow('bar_chart');
                    }}>
                        <h4>Bar chart</h4>
                        <img src={BarChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Pie chart</h4>
                        <img src={PieChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Range chart</h4>
                        <img src={RangeChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Bar chart with labels</h4>
                        <img src={BarChartWithLabelsDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Doughnut</h4>
                        <img src={DoughnutDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>State chart</h4>
                        <img src={StateChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Polar area</h4>
                        <img src={PolarAreaDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Radar</h4>
                        <img src={RadarDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Point chart</h4>
                        <img src={PointChartDisplayImage} alt="Chart"/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Value and chart card</h4>
                        <img src={ValueAndChartCardDisplayImage} alt="Chart"/>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ChartsWidgets;